import { createSelector } from 'reselect';

import { PAY_VALUE_BY_NAME } from '../../constants/payby';
import { translate } from '../../i18n';
import { DeliveryMode } from '../../types/Common';
import { DeliveryMethod } from '../../types/DeliveryMethod';
import { getIsTW } from '../../utils/countryInfo';
import { makeIsDeliveryDataLoading } from './recipientDetail';
import { makeIsCountriesFetching } from './VBConfigSelector';

export const makeIsLoadingInCheckoutPage = () => {
  return createSelector(
    makeIsDeliveryDataLoading(),
    makeIsCountriesFetching(),
    (isDeliveryLoading, isCountriesFetching) => {
      return isDeliveryLoading || isCountriesFetching;
    }
  );
};

const subtotalReducerRaw = state => state?.subtotalReducer || {};

export const makeDeliveryMethods = () => {
  return createSelector<[typeof subtotalReducerRaw], DeliveryMethod[]>(
    subtotalReducerRaw,
    data => {
      const deliveryModes =
        (data?.data?.allowed_delivery_modes as number[]) || [];
      const deliveryErrors = data?.data?.cvs_delivery_errors;

      const deliveryModeSet = new Set(deliveryModes);

      if (getIsTW()) {
        return [
          {
            pay_by: null,
            id: DeliveryMode.HOME_DELIVERY,
            text: translate('delivery-method-home'),
            is_allowed: deliveryModeSet.has(DeliveryMode.HOME_DELIVERY),
            cvs_delivery_errors: [],
          },
          {
            pay_by: PAY_VALUE_BY_NAME.COD,
            id: DeliveryMode.HOME_DELIVERY,
            text: translate('delivery-method-home-cod'),
            is_allowed: deliveryModeSet.has(DeliveryMode.HOME_DELIVERY),
            cvs_delivery_errors: [],
          },
          {
            pay_by: null,
            id: DeliveryMode.CONVENIENCE_STORE_PICKUP,
            text: translate('delivery-method-csv'),
            is_allowed: deliveryModeSet.has(
              DeliveryMode.CONVENIENCE_STORE_PICKUP
            ),
            cvs_delivery_errors: deliveryErrors,
          },
          // 先不要開超商貨到付款快速選項
          // {
          //   pay_by: PAY_VALUE_BY_NAME.COD,
          //   id: DeliveryMode.CONVENIENCE_STORE_PICKUP,
          //   text: translate('delivery-method-csv-cod'),
          //   is_allowed: deliveryModeSet.has(
          //     DeliveryMode.CONVENIENCE_STORE_PICKUP
          //   ),
          //   cvs_delivery_errors: deliveryErrors,
          // },
        ];
      } else {
        /**
         * 海外站點不支援超取 cod
         */
        return [
          {
            pay_by: null,
            id: DeliveryMode.HOME_DELIVERY,
            text: translate('home-delivery-for-gc'),
            is_allowed: deliveryModeSet.has(DeliveryMode.HOME_DELIVERY),
            cvs_delivery_errors: [],
          },
        ];
      }
    }
  );
};

export const makeDeliveryMethodsForCart = () => {
  return createSelector<[typeof subtotalReducerRaw], DeliveryMethod[]>(
    subtotalReducerRaw,
    data => {
      const deliveryModes =
        (data?.data?.allowed_delivery_modes as number[]) || [];
      const deliveryErrors = data?.data?.cvs_delivery_errors;

      const deliveryModeSet = new Set(deliveryModes);

      if (getIsTW()) {
        return [
          {
            pay_by: null,
            id: DeliveryMode.HOME_DELIVERY,
            text: translate('delivery-method-home'),
            is_allowed: deliveryModeSet.has(DeliveryMode.HOME_DELIVERY),
            cvs_delivery_errors: [],
          },
          {
            pay_by: null,
            id: DeliveryMode.CONVENIENCE_STORE_PICKUP,
            text: translate('delivery-method-csv'),
            is_allowed: deliveryModeSet.has(
              DeliveryMode.CONVENIENCE_STORE_PICKUP
            ),
            cvs_delivery_errors: deliveryErrors,
          },
        ];
      } else {
        /**
         * 海外站點不支援超取 cod
         */
        return [
          {
            pay_by: null,
            id: DeliveryMode.HOME_DELIVERY,
            text: translate('home-delivery-for-gc'),
            is_allowed: deliveryModeSet.has(DeliveryMode.HOME_DELIVERY),
            cvs_delivery_errors: [],
          },
        ];
      }
    }
  );
};

export const makeDeliveryMethodHasError = () => {
  return createSelector(makeDeliveryMethods(), methods => {
    return methods.some(method => method.cvs_delivery_errors?.length > 0);
  });
};
